import { DatapointIdStandardEnum, DatapointsEntityType } from "api/ux/src";
import { addCustomFieldsAsCols, addCustomFieldsAsDatapoints } from "components/modal/portfolio-creation-edit/helper";
import { filterTagLabels } from "components/tags/helpers";
import { CustomColumnType } from "components/widgets/grid/grid-column-types";
import { getMeasuresAndDimensionsWithCurrency, getMeasuresAndDimensionsWithoutCurrency } from "hooks/use-funds-page";
import { useGetCustomDatapointFields } from "hooks/widget-data/use-datapoints";
import { language } from "language/default";
const { assetClass } = language.en;
const mLanguage = language.en.administration.dataAdministration.exportData.investorAccounts;
export const useMeasuresAndDimensions = (currency, groups) => {
    const customFields = useGetCustomDatapointFields([DatapointsEntityType.Fund]), investorAccountCustomFields = useGetCustomDatapointFields(["Investor Account"]);
    const datapoints = [
        { datapoint: { standard: DatapointIdStandardEnum.FundInvestorId }, name: "Id" },
        { datapoint: { standard: DatapointIdStandardEnum.ManagerManagerId }, name: "ManagerId" },
        { datapoint: { standard: DatapointIdStandardEnum.FundFundId }, name: "FundId" },
        { datapoint: { standard: DatapointIdStandardEnum.FundFundName }, name: "Name" },
        { datapoint: { standard: DatapointIdStandardEnum.FundCurrency }, name: "Currency" },
        { datapoint: { standard: DatapointIdStandardEnum.ManagerManagerName }, name: "ManagerName" },
        { datapoint: { standard: DatapointIdStandardEnum.FundStrategy }, name: "Strategy" },
        { datapoint: { standard: DatapointIdStandardEnum.FundGeography }, name: "Geography" },
        { datapoint: { standard: DatapointIdStandardEnum.FundRemainingCommitment }, name: "Remaining Commitment" },
        { datapoint: { standard: DatapointIdStandardEnum.FundVintageYear }, name: "Vintage" },
        { datapoint: { standard: DatapointIdStandardEnum.FundInvestorName }, name: "InvestorName" }
    ];
    if (currency) {
        datapoints.push({ datapoint: { standard: DatapointIdStandardEnum.FundInvestorCurrency }, name: "InvestorCurrency" });
    }
    if (customFields) {
        addCustomFieldsAsDatapoints(customFields, datapoints);
        addCustomFieldsAsDatapoints(investorAccountCustomFields, datapoints);
    }
    const [fundIdDatapoint, managerIdDatapoint, investorIdDatapoint, ...mesureDatapoints] = datapoints;
    const { dimensions, measures } = currency
        ? getMeasuresAndDimensionsWithCurrency([...groups], mesureDatapoints)
        : getMeasuresAndDimensionsWithoutCurrency(mesureDatapoints);
    dimensions.push(managerIdDatapoint);
    dimensions.push(investorIdDatapoint);
    dimensions.push(fundIdDatapoint);
    return { dimensions, measures };
};
export const useCreateColInvestors = () => {
    const customFields = useGetCustomDatapointFields([DatapointsEntityType.Fund]), investorAccountCustomFields = useGetCustomDatapointFields(["Investor Account"]);
    const assetClassCol = [];
    assetClassCol.push({
        enableRowGroup: true,
        field: assetClass.gridTitle,
        type: CustomColumnType.InsTextSetColumn
    });
    const investorCols = [
        { field: "Id", hide: true, lockVisible: true },
        {
            checkboxSelection: true,
            field: "InvestorName",
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            headerName: mLanguage.investorAccount,
            type: CustomColumnType.InsTextSetColumn
        },
        {
            field: "Name",
            headerName: mLanguage.fundName,
            sort: "asc",
            type: [CustomColumnType.InsTextSetColumn],
            width: 280
        },
        { field: "InvestorCurrency", headerName: mLanguage.investorCurrency, type: CustomColumnType.InsTextSetColumn, width: 140 },
        { enableRowGroup: true, field: "Currency", headerName: mLanguage.fundCurrency, type: CustomColumnType.InsTextSetColumn, width: 140 },
        { enableRowGroup: true, field: "Vintage", headerName: mLanguage.vintageYear, type: CustomColumnType.InsTextSetColumn, width: 140 },
        { enableRowGroup: true, field: "Strategy", headerName: mLanguage.fundStrategy, type: CustomColumnType.InsTextSetColumn, width: 140 },
        { enableRowGroup: true, field: "Geography", headerName: mLanguage.fundGeography, type: CustomColumnType.InsTextSetColumn, width: 140 },
        {
            enableRowGroup: true,
            field: "tags",
            filter: "agSetColumnFilter",
            filterValueGetter: filterTagLabels,
            headerName: "Tags",
            type: [CustomColumnType.InsTagsColumn]
        }
    ];
    const cols = [
        { field: "FundId", hide: true, lockVisible: true },
        ...investorCols
    ];
    addCustomFieldsAsCols(customFields, cols);
    addCustomFieldsAsCols(investorAccountCustomFields, cols);
    return cols;
};
